export const isBuyerPriceEditLocked = (supplier) => {
  return supplier?.orderSettings?.lockBuyerPriceEdit === true;
};
